<style scoped lang="scss">
@import '../assets/style/_mixin.scss';

.login_body {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: #f5f5f5;
  text-align: center;
}
._brand {
  @include fluid-font-size(24px, 60px);
}
._logo {
  width: 40%;
  height: 40%;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>

<template>
  <div class="login_body">
    <form class="form-signin">
      <img class="_logo" :src="logo">
      <h1 class="h3 mb-3">Sign in</h1>
      <InputFloatLabel
        type="email"
        id="inputEmail"
        name="Account"
        placeholder="Email address"
        :autofocus="true"
        :value.sync="userAccount"
        rule="required|email"
      />
      <InputFloatLabel type="password" id="inputPassword" name="Password" placeholder="Password" :value.sync="userPassword" :keyup-enter-callback="clickSignIn"/>
      <div class="mb-3 d-flex justify-content-between align-items-baseline">
        <label>
          <input type="checkbox" v-model="rememberUser">
            <span class="small"> Remember me</span>
        </label>
        <router-link class="small" to="/forgot-password">forgot password?</router-link>
        <!-- <a class="small">forgot password?</a> -->
      </div>
      <div class="row">
        <div class="col-4 pr-1">
          <b-button :block="true" variant="outline-primary" to="/sign-up">Sign Up</b-button>
        </div>
        <div class="col-8 pl-1">
          <b-button :block="true" variant="primary" @click="clickSignIn()" :disabled="signInFormInvalid">Sign In</b-button>
        </div>
      </div>
      <p class="mt-5 mb-3 text-muted">© Intrising Networks, Inc.</p>
    </form>
  </div>
</template>

<script>
import { compact, size } from 'lodash'
import logo from '@/assets/intrising-logo/logo.svg'
import InputFloatLabel from '@/components/InputFloatLabel.vue'
import { signIn } from '@/firebaseRef'

export default {
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  components: {
    InputFloatLabel
  },
  data () {
    return {
      logo,
      userAccount: '',
      userPassword: '',
      rememberUser: true
    }
  },
  firebase () {
    return {

    }
  },
  computed: {
    signInFormInvalid () {
      const sif = [this.userAccount, this.userPassword]
      const isInputStrEmpty = compact(sif).length < size(sif) // check if any is ''
      const isInputError = this.errors.any()
      // console.log('signInFormInvalid', isInputError, this.errors)
      return isInputStrEmpty || isInputError
    }
  },
  methods: {
    async clickSignIn () {
      const { userAccount, userPassword, rememberUser } = this
      if (!this.signInFormInvalid) {
        await signIn(userAccount, userPassword, rememberUser)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SignIn.vue